"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.string.trim");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

var PctyDividerGridRow = function PctyDividerGridRow(_ref) {
  var label = _ref.label,
      columnSpan = _ref.columnSpan,
      __TYPE = _ref.__TYPE,
      other = (0, _objectWithoutProperties2.default)(_ref, ["label", "columnSpan", "__TYPE"]);
  var otherProps = other;
  otherProps.className = "".concat(other.className || '', " ").trim();
  return /*#__PURE__*/_react.default.createElement("tr", (0, _extends2.default)({
    className: "pcty-divider-row"
  }, otherProps), /*#__PURE__*/_react.default.createElement("td", {
    className: "pcty-divider",
    colSpan: columnSpan
  }, /*#__PURE__*/_react.default.createElement("span", null, label)));
};

PctyDividerGridRow.propTypes = {
  /** Label for the divider row */
  label: _propTypes.default.string.isRequired,

  /** The number of columns for the divider row to span across */
  columnSpan: _propTypes.default.number,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyDividerGridRow');
  }
  /** INCLUDE OTHER */

};
PctyDividerGridRow.defaultProps = {
  columnSpan: 1,
  __TYPE: 'PctyDividerGridRow'
};
var _default = PctyDividerGridRow;
exports.default = _default;